import { dsnToString, createEnvelope } from '@sentry/utils';
import { serializeMetricBuckets } from './utils.js';
/**
 * Create envelope from a metric aggregate.
 */

function createMetricEnvelope(metricBucketItems, dsn, metadata, tunnel) {
  var headers = {
    sent_at: new Date().toISOString()
  };

  if (metadata && metadata.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    };
  }

  if (!!tunnel && dsn) {
    headers.dsn = dsnToString(dsn);
  }

  var item = createMetricEnvelopeItem(metricBucketItems);
  return createEnvelope(headers, [item]);
}

function createMetricEnvelopeItem(metricBucketItems) {
  var payload = serializeMetricBuckets(metricBucketItems);
  var metricHeaders = {
    type: 'statsd',
    length: payload.length
  };
  return [metricHeaders, payload];
}

export { createMetricEnvelope };